import { cn } from "@/utils";
import { NavLink } from "react-router";
import logoUrl from "@/assets/icons/icon_512_white.png";

interface Props {
	size?: number | string;
	className?: string;
}
function Logo({ size = 50, className }: Props) {
	return (
		<NavLink to="/" className={cn(className)}>
			<img src={logoUrl} alt="logo" width={size} height={size} />
		</NavLink>
	);
}

export default Logo;
